(() => {
  function polishOffers() {
    document.querySelectorAll('.shopify-section--main-product .tes-auto-benefits-message').forEach(box=>{
      if(box.dataset.ctStyled)return;
      const copy=box.querySelector('.tes-auto-benefits-message__text');
      if(!copy)return;
      const tiers=[...copy.textContent.matchAll(/(\d+)%\s*off\s*US\$(\d+)\+/gi)];
      if(tiers.length!==3)return;
      box.dataset.ctStyled='true';
      const title=box.querySelector('.tes-auto-benefits-message__title');
      if(title)title.textContent='Save more on your order';
      const grid=document.createElement('div');grid.className='ct-offer-tiers';
      tiers.forEach(t=>{const cell=document.createElement('div'),amount=document.createElement('strong'),threshold=document.createElement('span');amount.textContent=t[1]+'% off';threshold.textContent='US$'+t[2]+'+';cell.append(amount,threshold);grid.append(cell);});
      copy.before(grid);copy.textContent='Applied at checkout · No code needed';
    });
  }
  polishOffers();
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const q = s => root.querySelector(s);
    const route = window.Shopify?.routes?.root || '/';
    const currency = root.dataset.currency || window.Shopify?.currency?.active || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100) + ' ' + currency;
    const main = JSON.parse(q('[data-main-json]').textContent);
    let mainVariant = main.variants.find(v => v.available) || main.variants[0];
    const status = q('[data-status]');
    const includeMain = q('[data-include-main]');
    let busy = false, uncertain = false, mainExplicit = false, activeCard = null, optionAction = 'choose';
    const cards = [...root.querySelectorAll('.ct-card')].map(el => {
      const product = JSON.parse(el.querySelector('[data-product-json]').textContent);
      return {el,product,variant:product.variants.length === 1 ? product.variants[0] : null};
    });
    const announce = text => {status.textContent = text;};
    const json = async (url, options={}) => {
      const res = await fetch(url, {...options,credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(20000)});
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'The request could not be completed.');
      return data;
    };
    const mainCount = cart => cart.items.filter(i => String(i.product_id) === String(main.id)).reduce((n,i) => n+i.quantity,0);
    function updateCartNote(cart) {
      const count = mainCount(cart);
      q('[data-main-state]').textContent = count ? `Already in your cart: ${count} charging hub${count>1?'s':''}. Check “Add 1 charging hub” only if you want another.` : 'This selection adds one charging hub when checked.';
      if (count && !mainExplicit) includeMain.checked = false;
      update();
    }
    function update() {
      let total = includeMain.checked ? mainVariant.price : 0;
      const names = includeMain.checked ? ['Charging hub × 1'] : [];
      for (const c of cards) {
        const v=c.variant,available=v?.available;
        c.el.querySelector('[data-price]').textContent = v ? money(v.price) : `From ${money(c.product.price_min)}`;
        c.el.querySelector('[data-choice]').textContent = v ? (v.title === 'Default Title' ? 'Standard option' : v.title) : 'Choose your option';
        const anyAvailable=c.product.variants.some(option=>option.available);
        c.el.querySelector('[data-add-one]').disabled = busy || uncertain || !anyAvailable;
        c.el.querySelector('[data-add-one]').textContent = !anyAvailable ? 'Sold out' : available ? 'Add to cart' : 'Choose & add';
        const check = c.el.querySelector('[data-include]');
        check.disabled = busy || uncertain || !anyAvailable;
        if (!available) check.checked = false;
        c.el.querySelector('[data-choose]').disabled = busy || uncertain;
        c.el.querySelector('[data-choose]').hidden = !v || c.product.variants.length === 1;
        c.el.querySelector('[data-choose]').textContent = 'Change option';
        if(check.checked) {total+=v.price;names.push(`${c.el.dataset.title} × 1 (${v.title === 'Default Title' ? 'Standard' : v.title})`);}
      }
      includeMain.disabled=busy || uncertain || !mainVariant.available;
      q('[data-total]').textContent=money(total);
      q('[data-summary]').textContent=names.length ? names.join(' · ') : 'Choose a hub or accessories to add.';
      const button=q('[data-add-bundle]');
      button.disabled=busy || uncertain || !names.length || (includeMain.checked && !mainVariant.available);
      button.textContent=busy?'Adding…':includeMain.checked?(names.length>1?'Add hub + selected accessories':'Add charging hub'):'Add selected accessories';
      root.setAttribute('aria-busy',String(busy));
    }
    const dialog=q('dialog');
    function choose(card, action = 'choose') {
      optionAction=action;
      q('[data-save-option]').textContent=action==='add'?'Add to cart':action==='include'?'Include in my set':'Use this option';
      activeCard=card;q('#ct-option-title').textContent=`Choose: ${card.el.dataset.title}`;
      const target=q('[data-options]');target.replaceChildren();
      card.product.variants.forEach(v => {
        const label=document.createElement('label');label.className='ct-option';
        const input=document.createElement('input');input.type='radio';input.name='ct-variant';input.value=v.id;input.disabled=!v.available;input.checked=card.variant?.id===v.id;
        const text=document.createElement('span');text.textContent=`${v.title === 'Default Title' ? 'Standard option' : v.title} — ${money(v.price)}${v.available?'':' · Sold out'}`;
        label.append(input,text);target.append(label);
      });
      dialog.showModal();
    }
    q('.ct-close').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    q('[data-save-option]').addEventListener('click',()=>{
      const selected=dialog.querySelector('input:checked');
      if(!selected){dialog.querySelector('input:not(:disabled)')?.focus();return;}
      activeCard.variant=activeCard.product.variants.find(v=>String(v.id)===selected.value);
      if(optionAction==='include')activeCard.el.querySelector('[data-include]').checked=true;
      update();dialog.close();
      if(optionAction==='add')add([activeCard],false);
    });
    cards.forEach(c=>{
      c.el.querySelector('[data-choose]').hidden=false;
      c.el.querySelector('[data-add-one]').hidden=false;
      c.el.querySelector('.ct-select-pair').hidden=false;
      c.el.querySelector('.ct-fallback').hidden=true;
      c.el.querySelector('[data-choose]').addEventListener('click',()=>choose(c));
      c.el.querySelector('[data-add-one]').addEventListener('click',()=>c.variant?.available?add([c],false):choose(c,'add'));
      c.el.querySelector('[data-include]').addEventListener('change',e=>{
        if(e.target.checked&&!c.variant?.available){e.target.checked=false;choose(c,'include');}
        else update();
      });
    });
    includeMain.addEventListener('change',()=>{mainExplicit=true;update();});
    q('[data-add-bundle]').addEventListener('click',()=>add(cards.filter(c=>c.el.querySelector('[data-include]').checked),includeMain.checked));
    q('.ct-bundle').hidden=false;
    async function add(selected,withMain) {
      if(busy||uncertain)return;
      busy=true;update();announce('Checking your selection…');
      let before=null,items=[],submitted=false;
      try {
        before=await json(route+'cart.js');
        if(withMain && mainCount(before)>0 && !mainExplicit){updateCartNote(before);announce('Your cart already contains the charging hub. Review the selection below; check the hub only if you want another.');return;}
        const sources=[...(withMain?[{handle:main.handle,variant:mainVariant,main:true}]:[]),...selected.map(c=>({handle:c.product.handle,variant:c.variant,card:c}))];
        if(!sources.length){announce('Choose at least one item.');return;}
        const fresh=await Promise.all(sources.map(s=>json(route+'products/'+encodeURIComponent(s.handle)+'.js')));
        let changed=false;
        for(let i=0;i<sources.length;i++){
          const s=sources[i],v=fresh[i].variants.find(v=>String(v.id)===String(s.variant.id));
          if(!v || !v.available){
            if(s.card){s.card.product=fresh[i];s.card.variant=v||null;}else if(v)mainVariant=v;
            throw new Error(`${s.card?.el.dataset.title || 'Charging hub'} is no longer available in this option. Choose another option.`);
          }
          if(v.price!==s.variant.price)changed=true;
          if(s.main)mainVariant=v;else{s.card.product=fresh[i];s.card.variant=v;}
          items.push({id:v.id,quantity:1});
        }
        if(changed){announce('A price changed. The subtotal is updated; review it and click Add again.');return;}
        const sections=[];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        const uniqueSections=[...new Set(sections)].slice(0,5);
        submitted=true;
        const result=await json(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:uniqueSections,sections_url:location.pathname})});
        const cart=await json(route+'cart.js');cart.sections=result.sections;
        announce(`Added ${items.length} item${items.length>1?'s':''} to your cart.`);
        mainExplicit=false;updateCartNote(cart);
        window.dataLayer?.push({event:'ct_hub_add_success',item_count:items.length,includes_hub:withMain});
        if(uniqueSections.length && uniqueSections.every(id=>result.sections?.[id])){
          root.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items,cart,onSuccessDo:'force_open_drawer'}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
        }else{document.dispatchEvent(new CustomEvent('cart:refresh'));location.assign(route+'cart');}
      } catch(e) {
        if(submitted){
          uncertain=true;
          try{
            const after=await json(route+'cart.js');
            const qty=(cart,id)=>cart.items.filter(i=>String(i.variant_id)===String(id)).reduce((n,i)=>n+i.quantity,0);
            const added=items.filter(i=>qty(after,i.id)>qty(before,i.id)).length;
            announce(`${added} of ${items.length} selected item types now show an increased quantity in your cart. ${e.message} Open your cart to review before adding again.`);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }catch{announce('We could not confirm the cart update. Open your cart to check before adding again.');}
        }else announce(e.message || 'Unable to check this selection. Please try again.');
      }finally{busy=false;update();}
    }
    update();
    json(route+'cart.js').then(updateCartNote).catch(()=>{});
    document.addEventListener('cart:change',e=>{if(e.detail?.cart)updateCartNote(e.detail.cart);});
  }
  document.querySelectorAll('[data-ct-hub]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ct-hub]').forEach(init));
})();
